import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

import NavbarLogo from "./NavbarLogo.js";

export default function HomeNavbar (props)
{
    return (
	<>
	    <Navbar expand="lg" className="bg-body-tertiary">
		<Container>
		    <NavbarLogo/>
		</Container>
	    </Navbar>
	</>
    );
}
